import Decimal from 'decimal.js-light'

// Meta verso l'alto: e la prassi fiscale, e la scelta va fatta una volta sola e qui.
Decimal.set({ precision: 34, rounding: Decimal.ROUND_HALF_UP })

export type Dec = Decimal

export function dec(v: string | number | Dec): Dec {
  return v instanceof Decimal ? v : new Decimal(String(v))
}

export const ZERO: Dec = dec('0')

export function somma(...valori: Dec[]): Dec {
  return valori.reduce<Dec>((a, b) => a.plus(b), ZERO)
}

export function sottrai(a: Dec, b: Dec): Dec {
  return a.minus(b)
}

export function moltiplica(a: Dec, b: Dec): Dec {
  return a.times(b)
}

export function arrotonda(v: Dec, decimali: number): Dec {
  return v.toDecimalPlaces(decimali, Decimal.ROUND_HALF_UP)
}

/**
 * Le regole di arrotondamento appartengono all'anno d'imposta, non al codice:
 * energia e importi si arrotondano in modo diverso e il tracciato puo cambiarlo.
 */
export interface Arrotondamento {
  readonly energia: number
  readonly importi: number
}
